import axios from 'axios'
import {config} from 'config.js'

var axiosGlobal = axios.create({
  timeout: 15000,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage['iPanel-apiToken']
  }
})

export const vipBrandsApi = {
  getVipBrands: async () => {
    try {
      const axiosconfig = {
        params: { }
      }
      const response = await axiosGlobal.get(`${config().apiBaseUrl}api/v1/vip/brands`, axiosconfig)
      return response.data
    } catch (error) {
      console.log(error)
      return { success: false }
    }
  }
}
